import { render, staticRenderFns } from "./StandardForm.vue?vue&type=template&id=6f80e618&"
import script from "./StandardForm.vue?vue&type=script&lang=js&"
export * from "./StandardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports